













































































































































































































import {Component, Mixins} from 'vue-property-decorator';
import MallInfoMixin from '@/components/product/ProductListMallInfoMixin';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import {DisplayEnum} from '@/types/enum';
import {namespace} from 'vuex-class';
const termsModule = namespace('terms');
import NcpLayer from '@/components/common/ncpLayerPopup/Index.vue';
import DateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import {changeDateFormat} from '@/utils/dateUtils';
import {momentAdd} from '@/utils/dateUtils';
import {centerWinOptions} from '@/utils/commonUtils';
import {toI18n} from '@/utils/commonUtils';

let reloadTemplate: Function;
window.addEventListener(
  'message',
  function (event: any) {
    if (event.data.templateNo) {
      reloadTemplate(event.data.templateNo);
    }
  },
  false
);

@Component({
  components: {
    PageFormSelect,
    NcpLayer,
    DateRangePicker
  }
})
export default class ModifyDelivery extends Mixins(MallInfoMixin) {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }

  @termsModule.Getter('getNcpLayerIsShow') private getNcpLayerIsShow!: boolean;
  @termsModule.Getter('getNcpLayerInfo') private popInfo!: {};
  @termsModule.Mutation('SET_NCPLAYERISSHOW') public setPopIsShow!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_POPINFO') public setPopInfo!: (popInfo: {}) => void;

  private get mallProductNos(): number[] {
    return this.$route.params.mallProductNos.split(',').map((no) => parseInt(no, 10));
  }

  private get mallNo(): number {
    return Number(this.$route.params.mallNo);
  }

  private get partnerNo(): number {
    return Number(this.$route.params.partnerNo);
  }

  private get isUSMall(): boolean {
    return this.USMallNos.includes(this.mallNo);
  }

  private get isHide(): string {
    return this.deliveryYn === 'Y' ? '' : 'hide';
  }

  private get isDeliveryDateHide(): string {
    return this.deliveryDateYn === 'Y' ? '' : 'hide';
  }

  private get isDeliveryPeriodYnHide(): boolean {
    return this.deliveryPeriodYn === 'Y' ? true : false;
  }

  private get isDeliveryCustomerInfoYnHide(): string {
    return this.deliveryCustomerInfoYn === 'Y' ? 'hide' : '';
  }

  private get isdaysAfterPurchaseYnHide(): string {
    return this.daysAfterPurchaseYn === 'Y' ? '' : 'hide';
  }

  private get getPeriod() {
    return this.deliveryPeriodYn === 'Y'
      ? {
          endDate: this.dateReceiveData.endYmd,
          startDate: this.dateReceiveData.startYmd
        }
      : null;
  }

  private get getDaysAfterPurchase() {
    return this.daysAfterPurchaseYn === 'Y' ? this.daysAfterPurchaseValue : null;
  }

  private deliveryDueDate = {
    daysOfTheWeek: [],
    period: {
      endDate: '',
      startDate: ''
    },
    daysAfterPurchase: '0'
  };

  private isBPC = false;
  private shippingAreaType: string = 'PARTNER_SHIPPING_AREA';
  private currrentPartnerNo = this.partnerNo;
  private currentTemplate: {[propName: string]: any} = {
    deliveryTypeLabel: '',
    deliveryCompanyType: '',
    deliveryFee: {deliveryConditionTypeLabel: '', returnDeliveryAmt: ''},
    releaseWarehouse: {
      summary: ''
    },
    returnWarehouse: {summary: ''}
  };
  private mapMallDeliveryPartner: Map<number, number> = new Map();
  private deliveryTemplateData: {[propName: string]: any}[] = [];
  private deliveryTemplate: DisplayEnum[] = [];
  private currentyTemplateNo = '';
  private deliveryYn = 'Y';
  private deliveryDateYn = 'N';
  private deliveryPeriodYn = 'N';
  private deliveryDaysOfWeek = ['MON', 'TUE', 'WED', 'THU', 'FRI'];
  private deliveryDaysOfWeekAll = true;
  private daysAfterPurchaseYn = 'N';
  private deliveryCombinationYn = 'Y';
  private deliveryInternationalYn = 'N';
  private deliveryCustomerInfoYn = 'Y';
  private deliveryCustomerInfo = '';
  private isBeforeFinish = true;

  private daysAfterPurchase = Array.from(Array(30).keys()).map((n) => {
    return {value: n + 1 + '', label: n + 1 + ' ' + this.toI18n('WORK')};
  });
  private daysAfterPurchaseValue = '1';
  private daysAfterPurchaseChange() {}

  private today: string = changeDateFormat('', 'YYYY-MM-DD');
  private initRangeStartYmd = this.today;

  private dateData: {startYmd: string; endYmd: string} = {
    startYmd: this.today,
    endYmd: momentAdd(this.today, [3, 'M'], 'YYYY-MM-DD')
  };

  private dateReceiveData = {...this.dateData};

  private dateDataChange({startYmd, endYmd}: any): void {
    this.dateReceiveData = {startYmd, endYmd};
  }

  private deliveryDaysOfWeekChange() {
    this.$nextTick(() => {
      if (this.deliveryDaysOfWeek.length === 5) {
        this.deliveryDaysOfWeekAll = true;
      } else {
        this.deliveryDaysOfWeekAll = false;
      }
    });
  }
  private deliveryDaysOfWeekAllChange() {
    if (this.deliveryDaysOfWeekAll) {
      this.deliveryDaysOfWeek = ['MON', 'TUE', 'WED', 'THU', 'FRI'];
    } else {
      this.deliveryDaysOfWeek = [];
    }
  }

  private deliveryTemplateChange() {
    Object.assign(this.currentTemplate, JSON.parse(JSON.stringify(this.deliveryTemplateData.find((item: any) => (item.templateNo as number) + '' === this.currentyTemplateNo))));
  }

  private async changeShippingAreaType(templateNo?: number) {
    if (this.shippingAreaType === 'PARTNER_SHIPPING_AREA') {
      this.currrentPartnerNo = this.partnerNo;
    } else {
      await this.currentMallParterNo().then((partnerNo) => {
        this.currrentPartnerNo = partnerNo;
      });
    }

    //setDeliveryTemplateBtn(isBPC && !isPartnerShippingArea);
    this.setDeliveryTemplate(templateNo);
  }

  private setDeliveryTemplate(templateNo?: number) {
    this.$api
      .getDeliveryTemplates({
        params: {
          partnerNo: this.currrentPartnerNo
        }
      })
      .then(({data}: any) => {
        this.deliveryTemplateData = data;
        this.deliveryTemplate = data.map((item: any) => {
          return {value: item.templateNo + '', label: item.name};
        });

        let templateObj = undefined;
        if (templateNo) {
          templateObj = data.find((item: any) => item.templateNo === templateNo - 0);
          if (templateObj){
            Object.assign(this.currentTemplate, JSON.parse(JSON.stringify(templateObj)));
          }
        } else {
          templateObj = data.find((item: any) => item.default);
          if (templateObj) {
            Object.assign(this.currentTemplate, JSON.parse(JSON.stringify(templateObj)));
          }
        }

        if (!templateObj && data.length) {
          Object.assign(this.currentTemplate, JSON.parse(JSON.stringify(data[0])));
        }

        this.currentyTemplateNo = this.currentTemplate.templateNo + '';
      });
  }

  private amtHelpPop() {
    const popInfo = {
      title: `${this.toI18n('MD_HELP_TEXT1')}`,
      subStyle: 'width:640px; max-height:500px; scroll-y:auto',
      noticeBox: `
<div class="notice_box">
    ${this.toI18n('MD_HELP_TEXT2')}
</div>
<div class="desc_area">
    <ul>
        <li>
            <div class="desc_tit">${this.toI18n('MD_HELP_TEXT3')}</div>
            <div class="desc_txt desc_eg">
                <p>${this.toI18n('MD_HELP_TEXT4')}</p>
                <p>${this.toI18n('MD_HELP_TEXT5')}</p>
            </div>
        </li>
    </ul>
</div>
    `
    };

    this.setPopInfo(popInfo);
    this.setPopIsShow(true);
  }

  private deliveryTemplatePop() {
    window.open('/deliveryTemplate/addForm?partnerNo=' + this.currrentPartnerNo, 'deliveryTemplateAdd', centerWinOptions(1050, 550));
  }

  private changeDeliveryYn() {
    setTimeout(() => {
      const contentWidth = $('#container').width() + 60;
      const contentHeight = $('.content').height() + 120;
      window.resizeTo(contentWidth, contentHeight);
    });
  }

  private save() {
    const params = {
      mallProductNos: this.mallProductNos.join()
    };

    let deliveryDueDate = {};
    if (this.deliveryDateYn === 'Y') {
      Object.assign(deliveryDueDate, {
        daysOfTheWeek: [...this.deliveryDaysOfWeek],
      })

      if (this.getPeriod) {
        Object.assign(deliveryDueDate, {
          period: this.getPeriod
        })
      }

      if (this.getDaysAfterPurchase) {
        Object.assign(deliveryDueDate, {
          daysAfterPurchase: Number(this.getDaysAfterPurchase)
        })
      }
    } else {
      deliveryDueDate = null;
    }

    const data: any = {
      deliveryYn: this.deliveryYn,
      deliveryCombinationYn: this.deliveryCombinationYn,
      deliveryInternationalYn: this.deliveryInternationalYn,
      deliveryTemplateNo: this.currentyTemplateNo,
      shippingAreaType: this.shippingAreaType,
      deliveryCustomerInfo: this.deliveryCustomerInfoYn === 'N' ? this.deliveryCustomerInfo : '',
      deliveryDueDate,
      shippingAreaPartnerNo: this.currentTemplate.partnerNo
    };

    this.$api.patchProducts({params, data}).then(({data}: any) => {
      window.opener.postMessage({modifyDelivery: true, data: JSON.parse(JSON.stringify(data))});
      this.close();
    });
  }

  private close() {
    window.close();
  }

  private currentMallParterNo(): Promise<any> {
    return new Promise((resolve: any, reject: any): void => {
      this.$api
        .getMallsDeliveryPartnersByMallNo({
          params: {
            mallNo: String(this.mallNo)
          }
        })
        .then(({data: {partnerNo}}: any) => {
          resolve(partnerNo);
        })
        .catch((error: any): void => {
          reject(error);
        });
    });
  }

  private created() {
    reloadTemplate = this.setDeliveryTemplate;
    document.body.classList.add('popup', 'popup_large');

    if (this.mallProductNos.length === 1) {
      this.$api
        .getProductsMallProductNo({
          pathParams: {
            mallProductNo: this.mallProductNos.toString()
          }
        })
        .then(({data}: any): void => {
          const {deliveryDueDate, deliveryYn, shippingAreaType, deliveryCombinationYn, deliveryInternationalYn, deliveryTemplateNo, deliveryCustomerInfo, applyStatusType} = data;
          Object.assign(this, {
            deliveryYn,
            shippingAreaType,
            deliveryCombinationYn,
            deliveryInternationalYn,
            deliveryCustomerInfo
          });

          if (deliveryDueDate) {
            Object.assign(this.deliveryDueDate, deliveryDueDate);
            const {period, daysOfTheWeek, daysAfterPurchase} = this.deliveryDueDate;
            if (period) {
              this.deliveryPeriodYn = 'Y';
              Object.assign(this.dateData, {
                startYmd: period.startDate,
                endYmd: period.endDate
              });
            } else {
              this.deliveryPeriodYn = 'N';
            }

            if (daysOfTheWeek && daysOfTheWeek.length) {
              this.deliveryDaysOfWeek = daysOfTheWeek;
              daysOfTheWeek.length === 5 ? (this.deliveryDaysOfWeekAll = true) : (this.deliveryDaysOfWeekAll = false);
            } else {
              this.deliveryDaysOfWeekAll = false;
              this.deliveryDaysOfWeek = [];
            }

            if (daysAfterPurchase && Number(daysAfterPurchase) > 0) {
              this.daysAfterPurchaseValue = daysAfterPurchase;
              this.daysAfterPurchaseYn = 'Y';
            } else {
              this.daysAfterPurchaseValue = '1';
              this.daysAfterPurchaseYn = 'N';
            }

            this.deliveryDateYn = 'Y';
          } else {
            this.deliveryDateYn = 'N';
          }

          if (deliveryCustomerInfo) {
            this.deliveryCustomerInfoYn = 'N';
          }

          if (['REGISTRATION_READY', 'APPROVAL_READY', 'APPROVAL_REJECTION', 'SALE_AGREEMENT_READY', 'SALE_AGREEMENT_REJECTION'].includes(applyStatusType)) {
            this.isBeforeFinish = false;
          }

          this.changeShippingAreaType(deliveryTemplateNo);
          this.changeDeliveryYn();
        });
    } else {
      this.setDeliveryTemplate();
      this.isBeforeFinish = false;
    }

    window.name = 'modifyDelivery';
  }
}
